import { AuthClientId, AuthDomain } from 'env-config';

import { Auth0Client } from 'auth0-spa-js';

const client = new Auth0Client({
    domain: AuthDomain(),
    client_id: AuthClientId()
});

export async function acquireAccessToken(audience: string, scope: string): Promise<string|null> {
    const tokenOptions = { audience, scope };
    const result = await client.getTokenSilently(tokenOptions)
                               .catch(() => client.getTokenWithPopup(tokenOptions));
    return result as string || null;
}